import { Checkbox, Col, Row } from 'antd'
import { CheckboxGroupProps } from 'antd/es/checkbox'

import { useIdentityRolesServiceGetRolesListEndpoint } from 'src/api/queries'

export const RolesCheckboxes = (props: CheckboxGroupProps) => {
  const { data } = useIdentityRolesServiceGetRolesListEndpoint({})

  return (
    <Checkbox.Group {...props}>
      <Row gutter={[24, 8]}>
        {data?.data?.map((role) => (
          <Col xs={24} md={12} xl={8} key={role.id}>
            <Checkbox value={role.id}>{role.name}</Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  )
}
